// University of Oklahoma's undergraduate majors (#2652). Read on 2026-10-01
// from the official 2026-2027 OU General Catalog's "Academic Majors,
// Undergraduate and Graduate" A to Z list (ou-public.courseleaf.com/academic-majors/,
// the catalog the Registrar links as the 2026-2027 General Catalog; it
// describes the Norman campus). The catalog is hosted off ou.edu, so each
// group cites the Registrar's ou.edu Catalog page that links it. Every
// bachelor's line is kept, grouped by the college in its catalog path;
// master's, doctoral, certificates, minors and the combined bachelor's and
// master's lines are left out. Degree abbreviations are the catalog's own
// (B.A., B.S., B.B.A., B.F.A., B.Mus., B.M.Ed., B.M.A., B.Ed., B. Arch.,
// B. in Arch. St., B.I.D., B. Phys., B.P.H.; "B.F.A" without the final dot is
// how the catalog writes Theatre: Costume Design Emphasis). Two names are
// typed with plain characters: the catalog's em dash in "Aviation:
// Aviation Management - Non-Flying Track" is a hyphen here, and "Women's &
// Gender Studies" uses a straight apostrophe. The Fine Arts note quotes
// OU's admissions page for the college (the college file's `fineArts`
// source). The KB's majors list was the starting point; the catalog wins.
const majors = {
    "slug": "university-of-oklahoma",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in OU's official 2026-2027 General Catalog for the Norman campus, grouped by the college that offers it, with the degree it leads to. Minors, certificates, combined bachelor's and master's programs and graduate programs are left out.",
    "groups": [
        {
            "name": "Christopher C. Gibbs College of Architecture",
            "source": {
                "label": "OU 2026-2027 General Catalog, Academic Majors (linked from the Registrar's Catalog page)",
                "url": "https://www.ou.edu/registrar/enrollment-services/course-information/catalog"
            },
            "majors": [
                {
                    "name": "Architecture, Four+ Year Program",
                    "degree": "B. Arch."
                },
                {
                    "name": "Architecture, Three+ Year Program",
                    "degree": "B. in Arch. St."
                },
                {
                    "name": "Construction Science",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Design",
                    "degree": "B.S."
                },
                {
                    "name": "Interior Design",
                    "degree": "B.I.D."
                }
            ]
        },
        {
            "name": "Dodge Family College of Arts and Sciences",
            "source": {
                "label": "OU 2026-2027 General Catalog, Academic Majors (linked from the Registrar's Catalog page)",
                "url": "https://www.ou.edu/registrar/enrollment-services/course-information/catalog"
            },
            "majors": [
                {
                    "name": "African and African-American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Asian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Astronomy",
                    "degree": "B.S."
                },
                {
                    "name": "Astrophysics",
                    "degree": "B.S."
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Biology: Ecology, Evolution, and Organismal Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biology: Integrative Biological Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Biology: Microbiology",
                    "degree": "B.S."
                },
                {
                    "name": "Biology: Molecular, Cellular, and Developmental Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical Biosciences",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry (Professional)",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry and Biochemistry (Standard Option)",
                    "degree": "B.S."
                },
                {
                    "name": "Classics: Classical Archaeology",
                    "degree": "B.A."
                },
                {
                    "name": "Classics: Classical Languages",
                    "degree": "B.A."
                },
                {
                    "name": "Classics: Classical Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Classics: Latin",
                    "degree": "B.A."
                },
                {
                    "name": "Communication",
                    "degree": "B.A."
                },
                {
                    "name": "Community Health",
                    "degree": "B.A."
                },
                {
                    "name": "Community Health",
                    "degree": "B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "English: Literary & Cultural Studies",
                    "degree": "B.A."
                },
                {
                    "name": "English: Writing",
                    "degree": "B.A."
                },
                {
                    "name": "European Studies",
                    "degree": "B.A."
                },
                {
                    "name": "European Studies: Russian & East European",
                    "degree": "B.A."
                },
                {
                    "name": "Film & Media Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Global Energy, Environment, and Resources",
                    "degree": "B.A."
                },
                {
                    "name": "Health & Exercise Science",
                    "degree": "B.S."
                },
                {
                    "name": "Health, Medicine, and Society",
                    "degree": "B.A."
                },
                {
                    "name": "History of Science, Technology, and Medicine",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Human Health & Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Human Relations",
                    "degree": "B.A."
                },
                {
                    "name": "Information Science and Technology",
                    "degree": "B.S."
                },
                {
                    "name": "Information Studies",
                    "degree": "B.A."
                },
                {
                    "name": "International Development",
                    "degree": "B.A."
                },
                {
                    "name": "International Security Studies",
                    "degree": "B.A."
                },
                {
                    "name": "International Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Japanese",
                    "degree": "B.A."
                },
                {
                    "name": "Judaic Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Latin American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Latinx Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Letters (Standard)",
                    "degree": "B.A."
                },
                {
                    "name": "Letters: Constitutional Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics (Professional Option)",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics (Standard Option)",
                    "degree": "B.A."
                },
                {
                    "name": "Microbiology (Standard)",
                    "degree": "B.S."
                },
                {
                    "name": "Microbiology (Standard): Biotechnology",
                    "degree": "B.S."
                },
                {
                    "name": "Middle Eastern Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Native American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics (Professional)",
                    "degree": "B. Phys."
                },
                {
                    "name": "Physics (Standard)",
                    "degree": "B.S."
                },
                {
                    "name": "Planned Program",
                    "degree": "B.A."
                },
                {
                    "name": "Planned Program",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science: Elections and Campaign Management",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science: Law and Policy",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology (Professional)",
                    "degree": "B.S."
                },
                {
                    "name": "Psychology (Standard)",
                    "degree": "B.A."
                },
                {
                    "name": "Public and Nonprofit Administration",
                    "degree": "B.A."
                },
                {
                    "name": "Public Health",
                    "degree": "B.P.H."
                },
                {
                    "name": "Religious Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Russian",
                    "degree": "B.A."
                },
                {
                    "name": "Social Work",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology - Criminology Option",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology - General Option",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Women's & Gender Studies",
                    "degree": "B.A."
                },
                {
                    "name": "World Languages and Cultures: Arabic",
                    "degree": "B.A."
                },
                {
                    "name": "World Languages and Cultures: Chinese",
                    "degree": "B.A."
                },
                {
                    "name": "World Languages and Cultures: French",
                    "degree": "B.A."
                },
                {
                    "name": "World Languages and Cultures: German",
                    "degree": "B.A."
                },
                {
                    "name": "World Languages and Cultures: Italian",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "College of Atmospheric and Geographic Sciences",
            "source": {
                "label": "OU 2026-2027 General Catalog, Academic Majors (linked from the Registrar's Catalog page)",
                "url": "https://www.ou.edu/registrar/enrollment-services/course-information/catalog"
            },
            "majors": [
                {
                    "name": "Aviation: Air Traffic Management Track",
                    "degree": "B.S."
                },
                {
                    "name": "Aviation: Aviation Management - Non-Flying Track",
                    "degree": "B.S."
                },
                {
                    "name": "Aviation: Aviation Management Track",
                    "degree": "B.S."
                },
                {
                    "name": "Aviation: Professional Pilot - Airplane Track",
                    "degree": "B.S."
                },
                {
                    "name": "Aviation: Professional Pilot - Helicopter Track",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Systems and Sustainability",
                    "degree": "B.S."
                },
                {
                    "name": "Geospatial Science",
                    "degree": "B.S."
                },
                {
                    "name": "Meteorology",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Michael F. Price College of Business",
            "source": {
                "label": "OU 2026-2027 General Catalog, Academic Majors (linked from the Registrar's Catalog page)",
                "url": "https://www.ou.edu/registrar/enrollment-services/course-information/catalog"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.B.A."
                },
                {
                    "name": "Energy Management",
                    "degree": "B.B.A."
                },
                {
                    "name": "Entrepreneurship and Venture Management",
                    "degree": "B.B.A."
                },
                {
                    "name": "Finance",
                    "degree": "B.B.A."
                },
                {
                    "name": "Healthcare Business",
                    "degree": "B.B.A."
                },
                {
                    "name": "International Business",
                    "degree": "B.B.A."
                },
                {
                    "name": "Management Information Systems",
                    "degree": "B.B.A."
                },
                {
                    "name": "Management",
                    "degree": "B.B.A."
                },
                {
                    "name": "Marketing",
                    "degree": "B.B.A."
                },
                {
                    "name": "Sports Business",
                    "degree": "B.B.A."
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "B.B.A."
                }
            ]
        },
        {
            "name": "Mewbourne College of Earth and Energy",
            "source": {
                "label": "OU 2026-2027 General Catalog, Academic Majors (linked from the Registrar's Catalog page)",
                "url": "https://www.ou.edu/registrar/enrollment-services/course-information/catalog"
            },
            "majors": [
                {
                    "name": "Environmental Geology",
                    "degree": "B.S."
                },
                {
                    "name": "GeoEnergy Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Geology",
                    "degree": "B.S."
                },
                {
                    "name": "Geophysics",
                    "degree": "B.S."
                },
                {
                    "name": "Paleontology",
                    "degree": "B.S."
                },
                {
                    "name": "Petroleum Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Petroleum Geology",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Jeannine Rainbolt College of Education",
            "source": {
                "label": "OU 2026-2027 General Catalog, Academic Majors (linked from the Registrar's Catalog page)",
                "url": "https://www.ou.edu/registrar/enrollment-services/course-information/catalog"
            },
            "majors": [
                {
                    "name": "Early Childhood Education",
                    "degree": "B.Ed."
                },
                {
                    "name": "Early Childhood Education: Birth through Third Grade (Tulsa)",
                    "degree": "B.Ed."
                },
                {
                    "name": "Elementary Education",
                    "degree": "B.Ed."
                },
                {
                    "name": "Language Arts Education",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics Education",
                    "degree": "B.S."
                },
                {
                    "name": "Science Education: Biological Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Science Education: Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Science Education: Earth Science",
                    "degree": "B.S."
                },
                {
                    "name": "Science Education: Physical Science",
                    "degree": "B.S."
                },
                {
                    "name": "Science Education: Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Social Studies Education",
                    "degree": "B.S."
                },
                {
                    "name": "Special Education",
                    "degree": "B.S."
                },
                {
                    "name": "World Language Education: French",
                    "degree": "B.S."
                },
                {
                    "name": "World Language Education: German",
                    "degree": "B.S."
                },
                {
                    "name": "World Language Education: Latin",
                    "degree": "B.S."
                },
                {
                    "name": "World Language Education: Spanish",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Gallogly College of Engineering",
            "source": {
                "label": "OU 2026-2027 General Catalog, Academic Majors (linked from the Registrar's Catalog page)",
                "url": "https://www.ou.edu/registrar/enrollment-services/course-information/catalog"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Applied Artificial Intelligence",
                    "degree": "B.S."
                },
                {
                    "name": "Architectural Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical Engineering (Standard)",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical Engineering - Bioengineering Option",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical Engineering - Pre-Medical Option",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical Engineering - Sustainability Option",
                    "degree": "B.S."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Cybersecurity",
                    "degree": "B.S."
                },
                {
                    "name": "Digital Manufacturing",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Engineering Analytics",
                    "degree": "B.S."
                },
                {
                    "name": "Engineering Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Science",
                    "degree": "B.S."
                },
                {
                    "name": "Healthcare Information Systems",
                    "degree": "B.S."
                },
                {
                    "name": "Industrial and Systems Engineering - Analytics Option",
                    "degree": "B.S."
                },
                {
                    "name": "Industrial and Systems Engineering - Pre-Medicine Option",
                    "degree": "B.S."
                },
                {
                    "name": "Industrial and Systems Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering (Standard)",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering - Premedical Option",
                    "degree": "B.S."
                },
                {
                    "name": "Software Development & Integration",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Weitzenhoffer Family College of Fine Arts",
            "source": {
                "label": "OU 2026-2027 General Catalog, Academic Majors (linked from the Registrar's Catalog page)",
                "url": "https://www.ou.edu/registrar/enrollment-services/course-information/catalog"
            },
            "majors": [
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Art",
                    "degree": "B.A."
                },
                {
                    "name": "Art, Technology & Culture",
                    "degree": "B.F.A."
                },
                {
                    "name": "Ballet Pedagogy",
                    "degree": "B.F.A."
                },
                {
                    "name": "Ballet Performance",
                    "degree": "B.F.A."
                },
                {
                    "name": "Composition",
                    "degree": "B.Mus."
                },
                {
                    "name": "Instrumental Music Education",
                    "degree": "B.M.Ed."
                },
                {
                    "name": "Modern Dance Performance",
                    "degree": "B.F.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.M.A."
                },
                {
                    "name": "Music: Instrumental Jazz",
                    "degree": "B.A."
                },
                {
                    "name": "Musical Theatre Performance",
                    "degree": "B.F.A."
                },
                {
                    "name": "Organ",
                    "degree": "B.Mus."
                },
                {
                    "name": "Piano",
                    "degree": "B.Mus."
                },
                {
                    "name": "Studio Arts",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theatre: Acting Emphasis",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theatre: Costume Design Emphasis",
                    "degree": "B.F.A"
                },
                {
                    "name": "Theatre: Dramaturgy Emphasis",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theatre: Lighting Design Emphasis",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theatre: Scenic Design Emphasis",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theatre: Sound Design Emphasis",
                    "degree": "B.F.A."
                },
                {
                    "name": "Theatre: Stage Management Emphasis",
                    "degree": "B.F.A."
                },
                {
                    "name": "Visual Communication",
                    "degree": "B.F.A."
                },
                {
                    "name": "Vocal Music Education",
                    "degree": "B.M.Ed."
                },
                {
                    "name": "Voice",
                    "degree": "B.Mus."
                }
            ],
            "note": "Dance, Drama, Music and Musical Theatre majors need a separate application to the school and an audition, on top of admission to OU.",
            "noteSource": "fineArts"
        },
        {
            "name": "Gaylord College of Journalism and Mass Communication",
            "source": {
                "label": "OU 2026-2027 General Catalog, Academic Majors (linked from the Registrar's Catalog page)",
                "url": "https://www.ou.edu/registrar/enrollment-services/course-information/catalog"
            },
            "majors": [
                {
                    "name": "Creative Media Production",
                    "degree": "B.S."
                },
                {
                    "name": "Journalism Advertising",
                    "degree": "B.S."
                },
                {
                    "name": "Journalism",
                    "degree": "B.S."
                },
                {
                    "name": "Professional Writing",
                    "degree": "B.S."
                },
                {
                    "name": "Public Relations",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Professional and Continuing Studies",
            "source": {
                "label": "OU 2026-2027 General Catalog, Academic Majors (linked from the Registrar's Catalog page)",
                "url": "https://www.ou.edu/registrar/enrollment-services/course-information/catalog"
            },
            "majors": [
                {
                    "name": "Criminal Justice (Online)",
                    "degree": "B.S."
                },
                {
                    "name": "Integrative Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Interdisciplinary Studies: Aerospace & Defense Management",
                    "degree": "B.S."
                },
                {
                    "name": "Interdisciplinary Studies: Business Administration",
                    "degree": "B.S."
                },
                {
                    "name": "Interdisciplinary Studies: Construction Management",
                    "degree": "B.S."
                },
                {
                    "name": "Interdisciplinary Studies: Criminal Justice Leadership",
                    "degree": "B.S."
                },
                {
                    "name": "Interdisciplinary Studies: Healthcare Management",
                    "degree": "B.S."
                },
                {
                    "name": "Interdisciplinary Studies: Learning and Education Studies",
                    "degree": "B.S."
                },
                {
                    "name": "Interdisciplinary Studies: Organizational Leadership",
                    "degree": "B.S."
                },
                {
                    "name": "Organizational Leadership",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Academic Affairs (Multidisciplinary Studies)",
            "source": {
                "label": "OU 2026-2027 General Catalog, Academic Majors (linked from the Registrar's Catalog page)",
                "url": "https://www.ou.edu/registrar/enrollment-services/course-information/catalog"
            },
            "majors": [
                {
                    "name": "Multidisciplinary Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Multidisciplinary Studies",
                    "degree": "B.S."
                }
            ]
        }
    ]
};

export default majors;
